import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { ReactComponent as PositiveYouMainBackground } from "shared/assets/positive-you/card-main-background.svg";
import { useTranslation } from "react-i18next";

export const PositiveYouCard = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "positiveYou" });
  return (
    <RoundedCard className="flex flex-col !p-0 overflow-hidden h-72">
      <div className="h-full relative flex flex-col overflow-hidden">
        <div className="h-full relative flex flex-col justify-between p-6 z-20">
          <div className="text-center">
            <p>{t("positiveYouMainCard.title")}</p>
            <h2 className="py-4">{t("positiveYouMainCard.question")}</h2>
          </div>
          <span className="text-xs text-white" dangerouslySetInnerHTML={{ __html: t("accreditation") }}></span>
        </div>
        <PositiveYouMainBackground className="scale-[1.1] absolute z-10 min-h-full left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2" />
      </div>
    </RoundedCard>
  );
};
